import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';

const SUITE_TAB_SKELETON_ROW_COUNT: number = 4;

const SuiteTabSkeleton = () => (
  <div style={{ padding: '1rem' }}>
    {Array.from({ length: SUITE_TAB_SKELETON_ROW_COUNT }, (_, index: number) => (
      <div key={`suite-tab-skeleton-${index}`} style={{ marginBottom: '0.75rem' }}>
        <Skeleton variant="rect" width="100%" height="3rem" />
      </div>
    ))}
  </div>
);

export default SuiteTabSkeleton;
